var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTealDiscountTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26037_7790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.666 5.33333H10.6593M14.666 3.46666L14.666 6.44967C14.666 6.77579 14.666 6.93885 14.6292 7.0923C14.5965 7.22835 14.5426 7.35841 14.4695 7.47771C14.3871 7.61226 14.2718 7.72756 14.0412 7.95817L8.92876 13.0706C8.13672 13.8626 7.74071 14.2586 7.28405 14.407C6.88236 14.5375 6.44967 14.5375 6.04798 14.407C5.59133 14.2586 5.19531 13.8626 4.40327 13.0706L2.92876 11.5961C2.13673 10.804 1.74071 10.408 1.59233 9.95136C1.46182 9.54967 1.46182 9.11698 1.59233 8.71529C1.74071 8.25864 2.13673 7.86262 2.92876 7.07058L8.04118 1.95817C8.27178 1.72756 8.38708 1.61226 8.52164 1.52981C8.64093 1.4567 8.77099 1.40283 8.90704 1.37017C9.06049 1.33333 9.22355 1.33333 9.54967 1.33333L12.5327 1.33333C13.2794 1.33333 13.6528 1.33333 13.938 1.47865C14.1889 1.60648 14.3929 1.81046 14.5207 2.06134C14.666 2.34656 14.666 2.71992 14.666 3.46666ZM10.3327 5.33333C10.3327 5.51742 10.4819 5.66666 10.666 5.66666C10.8501 5.66666 10.9993 5.51742 10.9993 5.33333C10.9993 5.14923 10.8501 4.99999 10.666 4.99999C10.4819 4.99999 10.3327 5.14923 10.3327 5.33333Z",
    stroke: "#008080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26037_7790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(-1 0 0 1 16 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTealDiscountTag);
export default __webpack_public_path__ + "static/media/teal-discount-tag.99172dbc35a7d004711d79071d7dcfcb.svg";
export { ForwardRef as ReactComponent };